export default __webpack_public_path__ + "static/media/OriginBit_white.7b09d3b1.png";